import { render, staticRenderFns } from "./Assinatura.vue?vue&type=template&id=2360db2d&scoped=true&"
import script from "./Assinatura.vue?vue&type=script&lang=js&"
export * from "./Assinatura.vue?vue&type=script&lang=js&"
import style0 from "./Assinatura.vue?vue&type=style&index=0&id=2360db2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2360db2d",
  null
  
)

export default component.exports